var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[(_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('the-loader')],1):_vm._e(),_c('b-embed',{ref:"iframe",attrs:{"type":"iframe","aspect":"21by9","src":_vm.url,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }